import { render, staticRenderFns } from "./wxLogin.vue?vue&type=template&id=3f31bfd3&scoped=true"
import script from "./wxLogin.vue?vue&type=script&lang=js"
export * from "./wxLogin.vue?vue&type=script&lang=js"
import style0 from "./wxLogin.vue?vue&type=style&index=0&id=3f31bfd3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f31bfd3",
  null
  
)

export default component.exports